import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { TransactionResult } from 'src/app/core/services/interfaces/transaction-result';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from 'src/app/core/translate/translate-application-service';
import { IMyApprovals } from '../../Interfaces/IMyApprovals';
import { ApproversAreasService } from '../../services/approversAreas-service';
import { IApproversAreas } from '../../Interfaces/IApproversAreas';
import { VisitsService } from '../../services/visits-service';
import { IVisitors } from '../../Interfaces/IVisitors';
import { IVisitorApprovalHistory } from '../../Interfaces/IVisitorApprovalHistory';

interface Item {
  label: string
}

@Component({
  selector: 'app-approval-history',
  templateUrl: './approval-history.component.html',
  styles: [
  ]
})
export class ApprovalHistoryComponent implements OnInit {
  activeIndex: number = 0;
  firstView: boolean = true;
  columnsApprovals: Array<any> = [
    'visitorname',
    'recordstatus',
    'approvername',
    'approvalrejectdate',
    'comment',
  ];
  columnsApprovers: Array<any> = [
    'employeename',
    'email',
  ];
  displayedColumns: Array<string> = this.columnsApprovals.map((c) => c.columnDef);
  hideListApprovers: boolean = true;
  items: MenuItem[] = [];
  listApprovalsAreas: Array<IApproversAreas> = [];
  listDataApprovals: Array<any> = [];
  listDataApprovers: Array<any> = [];
  listPKVisitors: Number[] = []
  listVisitorsByVisit: Array<IVisitors> = [];
  loading: boolean;
  maxActiveIndex: number = 0;

  constructor(
    private dialogRef: MatDialogRef<ApprovalHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IMyApprovals,
    private notificationService: NotificationService,
    private translateService: TranslateService,
    private formBuilder: FormBuilder,
    public translate: TranslateApplicationService,
    private approversAreasService: ApproversAreasService,
    private visitsService: VisitsService
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.GetApproversAreasByVisitorByVisit();
  }

  ActiveIndexChange(event) {
    this.loading = true;
    this.hideListApprovers = true;
    this.GetStatusApprovalsVisitorsByVisit(this.listApprovalsAreas[this.activeIndex].approverarea);
  }

  Alert(title: string, message: string) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: title,
			message: this.translate.TranslateKey(message),
			shown: true,
		});
  }

  ErrorAlert(message: any) {
    this.notificationService.AddAlert({
      icon: 'all_inbox',
      title: 'Error',
      message: message,
      shown: true,
    });
  }

  GetApproversAreasByVisitorByVisit() {
    this.approversAreasService.GetApproversAreasByVisitorByVisit(this.data.pkvisit)
      .subscribe(
        (result: TransactionResult<IApproversAreas[]>) => {
          if (result.success) {
            this.listApprovalsAreas = result.data;
            this.maxActiveIndex = result.data.length - 1;
            this.SetItemsFlow();
          } else {
            this.loading = false;
            this.Alert("Error", "MYREQUEST.Failed_to_retrieve_approval_areas");
          }
        },
        (error: any) => { this.ErrorAlert(error); this.loading = false; });
  }

  GetApproversByBuilding(approvalType: string) {
     this.approversAreasService.GetApproversByBuilding(this.data.fkbuilding, approvalType)
    .subscribe(
      (result: TransactionResult<IApproversAreas[]>) => {
        this.loading = false;
        if (result.success) {
          this.listDataApprovers = result.data;
        } else {
          this.loading = false;
          this.Alert("Error", "MYREQUEST.Error_getting_the_list_of_approvers_by_area");
        }
      },
      (error: any) => { this.ErrorAlert(error); this.loading = false; });
  }

  GetStatusApprovalsVisitorsByVisit(approvalType: string) {
    this.approversAreasService.GetStatusApprovalsVisitorsByVisit(this.data.pkvisit, approvalType)
    .subscribe(
      (result: TransactionResult<IVisitorApprovalHistory[]>) => {
        if (result.success) {
          this.listDataApprovals = result.data;
          
          let getApprovers = false;
          for (let x = 0; x < result.data.length; x++){
            if (result.data[x].recordstatus == "In progress") {
              this.hideListApprovers = false;
              getApprovers = true;
              break;
            }
          }

          if (getApprovers) {
            this.GetApproversByBuilding(approvalType);
          } else {
            this.loading = false;
          }
        } else {
          this.loading = false;
          this.Alert("Error", "MYREQUEST.Failed_to_get_approval_status");
        }
      },
      (error: any) => { this.ErrorAlert(error); this.loading = false; });
  }

  GetVisitorsByVisit() {
    this.visitsService.GetVisitorsByVisit(this.data.pkvisit)
      .subscribe(
        (result: TransactionResult<IVisitors[]>) => {
        this.loading = false;
        if (result.success) {
          this.listVisitorsByVisit = result.data;

          this.listVisitorsByVisit.forEach(element => {
            this.listPKVisitors.push(element.pkvisitor);
          });
          this.GetApproversAreasByVisitorByVisit();
        } else {
          this.loading = false;
          this.Alert("Error", "MYREQUEST.Failed_to_retrieve_visitors_per_visit");
        }
      },
      (error: any) => { this.ErrorAlert(error); this.loading = false; });
  }

  Next() {
    this.loading = true;
    this.activeIndex = this.activeIndex + 1;
    this.hideListApprovers = true;
    this.GetStatusApprovalsVisitorsByVisit(this.listApprovalsAreas[this.activeIndex].approverarea);
  }

  Previous() {
    this.loading = true;
    this.activeIndex = this.activeIndex - 1;
    this.hideListApprovers = true;
    this.GetStatusApprovalsVisitorsByVisit(this.listApprovalsAreas[this.activeIndex].approverarea);
  }

  SetItemsFlow() {
    let items: Item[] = [];
    let inProgressArea = '';
    this.listApprovalsAreas.forEach((ApprovalArea) => {
      if (inProgressArea == '' && ApprovalArea.inprogress == true) {
        inProgressArea = ApprovalArea.approverarea;
      }

      let item: Item = {
        label: ApprovalArea.approverarea
      }

      items.push(item);
    });

    this.items = items;

    if (inProgressArea != '') {
      this.firstView = false;
      for (let i = 0; i < this.listApprovalsAreas.length; i++){
        if (this.listApprovalsAreas[i].approverarea == inProgressArea) {
          this.activeIndex = i;
          break;
        }
      }
      this.GetStatusApprovalsVisitorsByVisit(inProgressArea);
    } else {
      this.activeIndex = this.listApprovalsAreas.length - 1;
      this.GetStatusApprovalsVisitorsByVisit(this.listApprovalsAreas[this.listApprovalsAreas.length - 1].approverarea);
    }
  }

}
